import useLaunchpadTileAction from '../../hooks/useLaunchpadTileAction';
import UnderstandIndicatorCard from '../UnderstandIndicatorCard/UnderstandIndicatorCard';

import type ILaunchpadStageCardProps from './interfaces/ILaunchpadStageCardProps';

// Merges a lane tile's action with its indicator content into a single lane card.
function LaunchpadStageCard({
  laneId,
  tile,
  indicator,
  hasActiveVcm,
  selectedMapId,
  onDiscoverClick,
}: ILaunchpadStageCardProps) {
  const { handleOpen, isHidden } = useLaunchpadTileAction({
    laneId,
    tile,
    hasActiveVcm,
    selectedMapId,
    onDiscoverClick,
  });

  if (isHidden) {
    return null;
  }

  return <UnderstandIndicatorCard indicator={indicator} onOpen={handleOpen} />;
}

export default LaunchpadStageCard;
